import { createSlice } from "@reduxjs/toolkit"

import wsClient from "src/wsClient"
import { addCasesForThunks } from "src/store/utils"

import initialState from "./initialState"
import thunks from "./thunks"
import reducers from "./reducers"

export const gameSlice = createSlice({
  name: "game",
  initialState: initialState,
  reducers: {
    ...reducers,
    reset: () => {
      if (wsClient.isConnected("game")) {
        wsClient.close("game")
      }
      return initialState
    },
  },
  extraReducers(builder) {
    addCasesForThunks(builder, thunks)
  },
})

// Export only the reducer actions to be ran outside of the context to thunks.
// In other words, using the dispatch(reducerName({...})).
// Remember, you can not await the dispatch of a reducer action.
export const {
  addChatMessage,
  addReaction,
  removeReaction,
  setGame,
  setGames,
  enterGame,
  setSpectatingAs,
  setWatchingThroughFog,
  setHistory,
  clearHistory,
  setRoundTrail,
  clearRoundTrail,
  setRoundMotion,
  clearRoundMotion,
  setPlayerPresence,
  setUserReady,
  leaveGame,
} = gameSlice.actions

// Reducer is used by the store to set the state of the user slice
export default gameSlice.reducer

// Export selectors and thunks to be able to be used from components easily
// in terms of the imports.
export * from "./thunks"
export * from "./selectors"
